import { render, staticRenderFns } from "./PIframe.vue?vue&type=template&id=1699aceb&"
import script from "./PIframe.vue?vue&type=script&lang=js&"
export * from "./PIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports